import { render, staticRenderFns } from "./dialog-newpreview.vue?vue&type=template&id=1ecf79b6&"
import script from "./dialog-newpreview.vue?vue&type=script&lang=js&"
export * from "./dialog-newpreview.vue?vue&type=script&lang=js&"
import style0 from "./dialog-newpreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports